import { render, staticRenderFns } from "./SetBusinessSuperiorDialog.vue?vue&type=template&id=366b0640&"
import script from "./SetBusinessSuperiorDialog.vue?vue&type=script&lang=ts&"
export * from "./SetBusinessSuperiorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SetBusinessSuperiorDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports